// app/@toast/default.tsx
'use client';

import { useEffect, useLayoutEffect, useState } from 'react';
import { notification } from 'antd';
import { useUIStore } from '@/shared/store/ui.store';
import { Z_TOAST } from '@/shared/ui/z-index';

export default function ToastSlot() {
  const [host, setHost] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    // Outer layer: no bloquea nada
    const layer = document.createElement('div');
    layer.id = 'toast-layer';
    layer.style.position = 'fixed';
    layer.style.top = '16px';
    layer.style.right = '16px';
    layer.style.zIndex = String(Z_TOAST);
    layer.style.pointerEvents = 'none';
    document.body.appendChild(layer);

    // Inner host: sí recibe eventos
    const hostEl = document.createElement('div');
    hostEl.id = 'toast-host';
    hostEl.style.pointerEvents = 'auto';
    layer.appendChild(hostEl);

    setHost(hostEl);

    return () => {
      document.body.removeChild(layer);
      setHost(null);
    };
  }, []);

  if (!host) return null;

  return <ToastInner host={host} />;
}

function ToastInner({ host }: { host: HTMLElement }) {
  const notificationData = useUIStore((s) => s.notification);
  const [api, contextHolder] = notification.useNotification({
    getContainer: () => host,
  });

  useEffect(() => {
    if (notificationData) {
      //console.log('notificationData----->', notificationData);

      const { message, description, duration, type } = notificationData;

      /* api.open({
        type,
        placement: 'topRight',
        duration,
        className: 'wv-toast',
        style: {
          background: 'rgba(18,18,22,0.96)',
          border: '1px solid rgba(255,255,255,0.12)',
          borderRadius: 12,
          boxShadow: '0 10px 28px rgba(0,0,0,.4)',
          backdropFilter: 'blur(3px)',
        },
        message: <span style={{ color: '#fff', fontSize: 17, fontWeight: 600, lineHeight: 1.5 }}>{message}</span>,
        description: <span style={{ color: '#fff', fontSize: 16, opacity: 1 }}>{description}</span>,
      });*/
      api.open({
        type,
        placement: 'topRight',
        duration,
        className: `wv-toast${type ? ` wv-toast--${type}` : ''}`,
        message: <span className='wv-toast__title'>{message}</span>,
        description: description ? <span className='wv-toast__desc'>{description}</span> : undefined,
      });
    }
  }, [api, notificationData]);

  return <>{contextHolder}</>;
}
